import './queryParamsTable.css';

interface QueryParamsTableProps {
  params: Record<string, string>;
}

export const QueryParamsTable: React.FC<QueryParamsTableProps> = ({
  params
}) => (
  <table className="qp-table">
    <tbody>
      {Object.entries(params).map(([key, value]) => (
        <tr key={key}>
          <td className="qp-key">{key}</td>
          <td className="qp-value">{value}</td>
        </tr>
      ))}
    </tbody>
  </table>
);
